/**
 * @generated SignedSource<<9c516f627f29dde0d4e0abb76cc5ff66>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type helpersMenuQuery$variables = {
  lastUsedTool?: number | null;
};
export type helpersMenuQuery$data = {
  readonly treeMenu: string;
};
export type helpersMenuQuery = {
  response: helpersMenuQuery$data;
  variables: helpersMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lastUsedTool"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lastUsedTool",
        "variableName": "lastUsedTool"
      }
    ],
    "kind": "ScalarField",
    "name": "treeMenu",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "helpersMenuQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "helpersMenuQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "2e5f4fa1704769d1237847dc3e83d3b3",
    "id": null,
    "metadata": {},
    "name": "helpersMenuQuery",
    "operationKind": "query",
    "text": "query helpersMenuQuery(\n  $lastUsedTool: Int\n) {\n  treeMenu(lastUsedTool: $lastUsedTool)\n}\n"
  }
};
})();

(node as any).hash = "6eddb10d9669ffde9cb8bb166c8d40cb";

export default node;
